import { styled } from '@mui/material/styles';
import { Paper, Box, Grid } from '@mui/material';

export const CenteredGrid = styled(Grid)(() => ({
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius * 2,
}));

export const FormBox = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(1),
}));

export const SubmitButton = {
    mt: 3,
    mb: 2,
};

export const MessageText = {
    marginBottom: 16,
    textAlign: 'center',
};
